import { path } from "../utils";
import { ChandeMomentum as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = { ...defaultOptions };

  function calculator(data = []) {
    const { period, sourcePath } = options;

    if (data.length < period + 1) {
      return [];
    }

    const getPrice = path(sourcePath);
    const results = [];

    let sumMomentum = 0;
    let absSumMomentum = 0;
    const history = [];

    for (let i = 0; i < data.length; i++) {
      if (i < 1) {
        results.push(undefined);
        continue;
      }

      const currentPrice = getPrice(data[i]);
      const prevPrice = getPrice(data[i - 1]);

      // Handle undefined or null prices
      if (currentPrice == null || prevPrice == null || prevPrice === 0) {
        results.push(undefined);
        continue;
      }

      // Calculate price difference
      const diff = currentPrice - prevPrice;

      history.push(diff);
      sumMomentum += diff;
      absSumMomentum += Math.abs(diff);

      // Once we have enough history, calculate CMO
      if (history.length === period) {
        // CMO = 100 × (sumMomentum / absSumMomentum)
        // Avoid division by zero
        const cmo =
          absSumMomentum !== 0 ? (100 * sumMomentum) / absSumMomentum : 0;

        results.push(cmo);

        // Remove oldest value from sums
        const old = history.shift();
        sumMomentum -= old;
        absSumMomentum -= Math.abs(old);
      } else {
        results.push(undefined);
      }
    }

    return results;
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    return period;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return { ...options };
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
